// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';
import { Grid, Box, Card, Typography, List, ListItem } from '@mui/material';
import { PiPasswordBold } from 'react-icons/pi';
import { IoMail } from 'react-icons/io5';
import { HiMailOpen } from 'react-icons/hi';
import { MdOutlineMailLock } from 'react-icons/md';

import Logo from 'src/layouts/full/shared/logo/Logo';
import PageContainer from 'src/components/container/PageContainer';

import ChangeEmailForm from './ChangeEmailForm';
import { Link } from 'react-router-dom';

const ChangeEmail = () => (
  <PageContainer title="Change Email" description="this is Change Email page" sx={{ height: '100vh', bgcolor: 'primary.light' }}>
    <Box sx={{ ml: 3, position: 'absolute' }}>
      <Logo align={'start'} />
    </Box>
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      {/* <Box sx={{ gradientStyles }}> */}
      <Grid container spacing={0} justifyContent="center" alignItems={'center'}>
        <Grid
          display="flex"
          justifyContent="center"
          alignItems="center"
          size={{
            xs: 12,
            sm: 12,
            lg: 4,
            xl: 3
          }}>
          <Card elevation={2} sx={{ p: 8, zIndex: 1, width: '100%', maxWidth: '600px', minWidth: '400px' }}>
            <Box sx={{ color: 'primary.main', display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
              <MdOutlineMailLock size={46} />
            </Box>
            <Typography color="textSecondary" textAlign="center" variant="h4" fontWeight="800" sx={{ mb: 2 }}>
              Confirm Change Email
            </Typography>
            <ChangeEmailForm />
          </Card>
        </Grid>
      </Grid>
    </Box>
  </PageContainer>
);

export default ChangeEmail;

// const gradientStyles = {
//   position: 'relative',
//   '&:before': {
//     content: '""',
//     background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
//     backgroundSize: '400% 400%',
//     animation: 'gradient 15s ease infinite',
//     position: 'absolute',
//     height: '100%',
//     width: '100%',
//     opacity: '0.3',
//   },
// };
